import { getLocation } from '@nibfe/mkt-lbs-api';
import { useEffect, useState } from '@max/max';
export function useLocation(sceneToken) {
    const [location, setLocation] = useState();
    const [done, setDone] = useState(false);
    useEffect(() => {
        async function _() {
            try {
                const location = await getLocation({
                    sceneToken
                });
                setLocation({
                    lat: String(location.lat),
                    lng: String(location.lng)
                });
            }
            catch (err) {
                console.error('Failed to get location', err);
            }
            finally {
                setDone(true);
            }
        }
        _();
    }, []);
    return {
        location,
        locationDone: done
    };
}
